import React from "react";
import { api, unwrap, errMsg } from "@/lib/api";
import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { FileText, Download } from "lucide-react";
import { toast } from "sonner";

export default function Compliance() {
  const { data: reports } = useQuery({ queryKey: ["compliance-reports"], queryFn: async () => unwrap(await api.get("/compliance/reports")) });
  const download = async (code, board) => {
    try {
      const resp = await api.get(`/compliance/${code}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const a = document.createElement("a");
      a.href = url; a.download = `${code}-${new Date().toISOString().slice(0, 10)}.csv`;
      a.click(); window.URL.revokeObjectURL(url);
      toast.success(`${board} report downloaded`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="p-6 lg:p-8" data-testid="compliance-page">
      <div className="mb-6">
        <h1 className="font-display text-3xl font-bold text-[var(--text-primary)]">Government compliance</h1>
        <p className="text-sm text-[var(--text-muted)] mt-1">CSV exports for CBSE / ICSE / UGC annual returns</p>
      </div>
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
        {(reports || []).map((r) => (
          <Card key={r.code} className="border-[var(--subtle)]" data-testid={`report-${r.code}`}>
            <CardHeader>
              <div className="flex items-center justify-between">
                <Badge className="bg-[var(--accent-bg)] text-[var(--accent)] border-0">{r.board}</Badge>
                <FileText className="h-5 w-5 text-[var(--text-muted)]" />
              </div>
              <CardTitle className="text-base font-display mt-2">{r.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-[var(--text-secondary)] mb-4">{r.description}</p>
              <Button size="sm" onClick={() => download(r.code, r.board)} data-testid={`download-${r.code}`} className="bg-[var(--accent)] hover:bg-[var(--accent-hover)] text-white w-full">
                <Download className="h-4 w-4 mr-1.5" /> Download CSV
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
